/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  UpdateEncounterMessagesToReadErrorResponse,
  UpdateEncounterMessagesToReadRequest,
} from './api.schemas';

import { api } from '../util/http';

export const updateEncountersMessages = (
  encounterId: number,
  updateEncounterMessagesToReadRequest: UpdateEncounterMessagesToReadRequest,
) => {
  return api<void>({
    url: `/api/encounters/${encounterId}/messages`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateEncounterMessagesToReadRequest,
  });
};

export const getUpdateEncountersMessagesMutationOptions = <
  TError = UpdateEncounterMessagesToReadErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEncountersMessages>>,
    TError,
    { encounterId: number; data: UpdateEncounterMessagesToReadRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEncountersMessages>>,
  TError,
  { encounterId: number; data: UpdateEncounterMessagesToReadRequest },
  TContext
> => {
  const mutationKey = ['updateEncountersMessages'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEncountersMessages>>,
    { encounterId: number; data: UpdateEncounterMessagesToReadRequest }
  > = (props) => {
    const { encounterId, data } = props ?? {};

    return updateEncountersMessages(encounterId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEncountersMessagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEncountersMessages>>
>;
export type UpdateEncountersMessagesMutationBody = UpdateEncounterMessagesToReadRequest;
export type UpdateEncountersMessagesMutationError = UpdateEncounterMessagesToReadErrorResponse;

export const useUpdateEncountersMessages = <
  TError = UpdateEncounterMessagesToReadErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEncountersMessages>>,
      TError,
      { encounterId: number; data: UpdateEncounterMessagesToReadRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEncountersMessages>>,
  TError,
  { encounterId: number; data: UpdateEncounterMessagesToReadRequest },
  TContext
> => {
  const mutationOptions = getUpdateEncountersMessagesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
